<template>
  <div class="page-projectAreaDetail">
     <div class="page-projectAreaDetail-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><span @click="$router.go(-1)">{{projectName}}</span></el-breadcrumb-item>
          <el-breadcrumb-item>
            <el-dropdown :hide-on-click="false" @command="selectArea">
              <span class="el-dropdown-link">
                {{aeraName}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" v-show='proAreaList'>
                <el-dropdown-item v-for="item in proAreaList"
                :key="item.id" :command="item">{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="projectAreaDetail-header-right">
      </div>
    </div>
    <div class="main-cont">
      <div class="main-cont-left">
         <div class="page-projectAreaDetail-second">
      <div class="dev1 Radius">
      <pointer :ihai="ihai"></pointer>
      </div>
      <div class="dev1 Radius">
        <showNum :items='item2' :crTime="crTime" :devId="devId"></showNum>
      </div>
      <div class="dev3 Radius">
        <outNum :crTime="crTime" :aqi="item3" :proCity="proCity"></outNum>
      </div>
      </div>
      <div class="zhedian Radius">
        <newZhe :devArr="deviceList" :areaId="areaId" :devId='devId' @clearBlue="clearB()" :devParams="dt"></newZhe>
      </div>
      </div>
      <div class="main-cont-right Radius">
        <comBox>
          <template v-slot:name>
            <h4>{{$store.state.module1.isChina?'设备详情':'Device detail'}}</h4>
          </template>
          <template v-slot:content>
            <div class="allDev">
              <div style="cursor:pointer;" @click="choseState('')"><p>{{areaInfo.dev_detail.allNum}}</p>{{$store.state.module1.isChina?'所有设备':'All'}}</div>
              <div style="cursor:pointer;" @click="choseState('在线')"><p>{{areaInfo.dev_detail.online}}</p>{{$store.state.module1.isChina?'在线设备':'Online'}}</div>
              <div style="cursor:pointer;" @click="choseState('离线')"><p>{{areaInfo.dev_detail.offline}}</p>{{$store.state.module1.isChina?'离线设备':'Off-line'}}</div>
            </div>
            <div v-if="devLists">
              <div v-for="(dev, index) in devLists" :key="index" class="devLi" :class="dev.color">
                <el-tooltip class="item" effect="light" :content="$store.state.module1.isChina?'点我查看数据':'view data'" placement="right">
                </el-tooltip>
                <div>
                  <p @click="choseDev(dev.code, $event)" style="cursor:pointer;">{{dev.dname}}</p>
                  <span style="display:inline-block;width:62%;">{{$store.state.module1.isChina?'设备识别号':'SN'}}：{{dev.code}}</span>
                </div>
                <div class="showLine" :style='{background:background(dev.state)}'>
                  <div></div>
                  {{dev.state}}
                </div>
              </div>
              <el-pagination small layout="prev, pager, next" :page-size="6" :total="proDevNum1" @current-change="changePage" :current-page="page">
              </el-pagination>
            </div>
          </template>
        </comBox>
      </div>
    </div>
  </div>
</template>

<script>
import { Mixin } from '../../../mixins/index.js'
import newZhe from '../../../components/newZhe/newZhe.vue'
import pointer from '../../../components/pointer/pointer.vue'
import showNum from '../../../components/showNum/showNum.vue'
import outNum from '../../../components/outNum/outNum.vue'
import comBox from '../../../components/comBox/comBox.vue'
import { stringTime, requestData } from '../../../assets/js/commont.js'
export default {
  name: 'projectAreaDetail',
  mixins: [Mixin],
  inject: ['reToken'],
  components: {
    pointer,
    newZhe,
    showNum,
    comBox,
    outNum
  },
  data () {
    return {
      value6: '',
      devArr: null,
      aeraName: '',
      crTime: '',
      devId: [],
      dt: [],
      parmasList: [],
      areaId: '',
      devLists: null,
      page: 1,
      classArr: ['blue', 'green', 'orange'],
      colorArr: [],
      ihai: '',
      io: 999,
      proCity: '',
      state: '',
      item1: [
        { name: '设备点位', value: 0 },
        { name: '离线设备', value: 0 },
        { name: '在线设备', value: 0 },
        { name: '异常设备', value: 0 }
      ],
      item2: [],
      item3: null
    }
  },
  methods: {
    // 切换单位
    changUnit () {
      this.changeUstate = !this.changeUstate
      var unit = JSON.parse(window.localStorage.getItem('unit'))
      if (unit) {
        this.item2.forEach(item => {
          if (item.name === 'PM2.5') {
            if (unit[0].unit === 'mg/m³') {
              item.unit = 'mg/m³'
              if (!this.devId.length) {
                this.areaInfo.params.forEach(param => {
                  if (param.name === 'pm25') {
                    item.value = parseFloat((param.value * 0.001).toFixed(4))
                  }
                })
              } else {
                this.parmasList.forEach(param => {
                  if (param.name === 'PM2.5') {
                    item.value = parseFloat((param.value * 0.001).toFixed(4))
                  }
                })
              }
            } else {
              item.unit = 'μg/m³'
              if (!this.devId.length) {
                this.areaInfo.params.forEach(param => {
                  if (param.name === 'pm25') {
                    item.value = parseFloat(param.value)
                  }
                })
              } else {
                this.parmasList.forEach(param => {
                  if (param.name === 'PM2.5') {
                    item.value = parseFloat(param.value)
                  }
                })
              }
            }
          }
          if (item.name === 'TVOC') {
            if (unit[1].unit === 'mg/m³') {
              item.unit = 'mg/m³'
              if (!this.devId.length) {
                this.areaInfo.params.forEach(param => {
                  if (param.name === 'tvoc') {
                    item.value = parseFloat((param.value * 0.0013).toFixed(4))
                  }
                })
              } else {
                this.parmasList.forEach(param => {
                  if (param.name === 'TVOC') {
                    item.value = parseFloat((param.value * 0.0013).toFixed(4))
                  }
                })
              }
            } else {
              item.unit = 'ppb'
              if (!this.devId.length) {
                this.areaInfo.params.forEach(param => {
                  if (param.name === 'tvoc') {
                    item.value = parseFloat(param.value)
                  }
                })
              } else {
                this.parmasList.forEach(param => {
                  if (param.name === 'TVOC') {
                    item.value = parseFloat(param.value)
                  }
                })
              }
            }
          }
          if (item.name === 'HCHO') {
            if (unit[2].unit === 'mg/m³') {
              item.unit = 'mg/m³'
              if (!this.devId.length) {
                this.areaInfo.params.forEach(param => {
                  if (param.name === 'hcho') {
                    item.value = parseFloat((param.value * 0.0012).toFixed(4))
                  }
                })
              } else {
                this.parmasList.forEach(param => {
                  if (param.name === 'HCHO') {
                    item.value = parseFloat((param.value * 0.0012).toFixed(4))
                  }
                })
              }
            } else {
              item.unit = 'ppb'
              if (!this.devId.length) {
                this.areaInfo.params.forEach(param => {
                  if (param.name === 'hcho') {
                    item.value = parseFloat(param.value)
                  }
                })
              } else {
                this.parmasList.forEach(param => {
                  if (param.name === 'HCHO') {
                    item.value = parseFloat(param.value)
                  }
                })
              }
            }
          }
        })
      }
    },
    // 获取AQI
    getAqi () { // 重构中不管
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        city: this.proCity,
        token: window.localStorage.getItem('token'),
        time: time.substring(0, 10),
        ts: time
      }
      this.getCityaqi(requestData(data))
    },
    // 切换设备状态
    choseState (state) {
      this.state = state
    },
    // 切换页面
    changePage (index) {
      this.page = index
      this.getDevList()
      this.clearall()
    },
    // 清除选项
    clearall () {
      var doc1 = document.getElementsByClassName('devLi')
      var doc = Array.from(doc1)
      if (doc.length) {
        doc.forEach(item => {
          item.className = 'devLi'
        })
      }
    },
    // 清除背景色
    clearB () {
      this.clearall()
      this.devId = []
    },
    // 选择设备
    choseDev (code, e) {
      var class1 = null
      try {
        if (this.devId.length < 3 && this.devId.length > 0) {
          this.devId.forEach((id, index) => {
            if (id.dev === code) {
              this.devId.splice(index, 1)
              class1 = e.srcElement.parentNode.parentNode.className.substring(6)
              this.classArr.push(class1)
              e.srcElement.parentNode.parentNode.className = 'devLi'
              throw new Error('77')
            } else {
              if (index === this.devId.length - 1) {
                var color = this.classArr.shift()
                this.devId.push({ dev: code, color: color })
                e.srcElement.parentNode.parentNode.className = `devLi ${color}`
              }
            }
          })
        } else if (this.devId.length === 3) {
          this.devId.forEach((id, index) => {
            if (id.dev === code) {
              this.devId.splice(index, 1)
              class1 = e.srcElement.parentNode.parentNode.className.substring(6)
              this.classArr.push(class1)
              e.srcElement.parentNode.parentNode.className = 'devLi'
              throw new Error('55')
            } else {
              if (index === 2) {
                this.$message({
                  message: this.$store.state.module1.isChina ? '最多同时查看3台设备' : 'View up to 3 devices at the same time',
                  type: 'warning'
                })
              }
            }
          })
        } else {
          this.classArr = ['blue', 'green', 'orange']
          var color = this.classArr.shift()
          this.devId.push({ dev: code, color: color })
          e.srcElement.parentNode.parentNode.className = `devLi ${color}`
        }
      } catch (err) {

      }
    },
    background (state) {
      if (state === '离线') {
        return '#ccc'
      }
      return '#00C657'
    },
    // 选择区域
    selectArea (item) {
      this.aeraName = item.name
      this.areaId = item.id
    },
    // 获取地区详细 --------------------------- 接口
    getAreaInfoDetail () {
      var time = stringTime(this.$myTime())
      var id = parseInt(this.areaId)
      var data = {
        account: window.localStorage.getItem('account'),
        area_id: id,
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getAreaInfo(requestData(data)).then(value => {
        if (!this.devId.length) {
          this.parmasList = []
          this.dt = []
          value.params.forEach(item => {
            var data = {
              name: item.name.toUpperCase(),
              value: 0,
              unit: item.unit
            }
            if (data.name === 'HUMIDITY') {
              data.name = 'RH'
            }
            if (data.name === 'TEMPERATURE') {
              data.name = 'TEMP'
            }
            if (data.name === 'PM25') {
              data.name = 'PM2.5'
            }
            if (item.name !== 'ihai') {
              this.dt.push(item.name)
              this.parmasList.push(data)
            }
          })
        }
      })
    },
    // 获取地区设备列表 --------------------------- 接口
    getDevList () {
      var id = parseInt(this.areaId)
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        area_id: id,
        limit: 6,
        page: this.page,
        state: this.state,
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getDeviceList(requestData(data))
    },
    getAreaL () {
      // 获取区域列表 --------------------------- 接口
      var id = this.$route.params.id + ''
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        project_id: id,
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getProAreaList(requestData(data))
    },
    // 替换shouNUM数据
    changeNum () {
      // 在线设备
      this.item1[0].value = this.areaInfo.dev_detail.allNum
      this.item1[1].value = this.areaInfo.dev_detail.offline
      this.item1[2].value = this.areaInfo.dev_detail.online
      this.item1[3].value = this.areaInfo.dev_detail.allNum - this.areaInfoFirst.dev_detail.offline - this.areaInfoFirst.dev_detail.online
      if (!this.item1[3].value) {
        this.item1[3].value = 0
      }
      // 数据
      if (!this.devId.length) {
        if (this.areaInfo.params) {
          this.item2 = []
          this.areaInfo.params.forEach(item => {
            var data = {
              name: item.name.toUpperCase(),
              value: item.value,
              unit: item.unit,
              nickname: item.nickname
            }
            if (data.name !== 'IHAI') {
              if (data.name === 'HUMIDITY') {
                data.name = 'RH'
              }
              if (data.name === 'TEMPERATURE') {
                data.name = 'TEMP'
              }
              if (data.name === 'PM25') {
                data.name = 'PM2.5'
              }
              this.item2.push(data)
            } else {
              this.ihai = parseFloat(item.value) / 100
            }
          })
          // 针对颐堤港项目
          /*
          this.$http.get('http://api.k780.com/?app=weather.today&weaid=1&appkey=55495&sign=80bd949661c9f4873dc6ac5c4b992820&format=json').then(data => {
            this.item2.forEach(it => {
              if (it.name === 'TEMP') {
                it.value = data.data.result.temp_curr
              } else if (it.name === 'RH') {
                it.value = data.data.result.humidity
              }
            })
          })
          */
        }
      }
      this.ihai = Number(String(this.ihai).substring(0, 5))
      if (this.ihai === 0.58) {
        this.ihai = 0.59
      }
      this.changUnit()
    },
    depCopy (child, parent) {
      for (var key in parent) {
        if (parent[key] instanceof Object) {
          if (Array.isArray(key)) {
            child[key] = []
            this.depCopy(child[key], parent[key])
          } else {
            child[key] = {}
            this.depCopy(child[key], parent[key])
          }
        } else {
          child[key] = parent[key]
        }
      }
    }
  },
  created () {
    // 获取AQI没问题
    this.proCity = window.localStorage.getItem('proCity')
    this.getAqi()
    // 获取地区列表
    this.getAreaL()
    this.crTime = stringTime(this.$myTime())
    // 每分钟获取一次地区详情信息
    const timerId = setInterval(() => {
      this.crTime = stringTime(this.$myTime())
      this.getAreaInfoDetail()
    }, 60000)
    // 销毁定时器最终写法
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timerId)
      clearInterval(this.timerId3)
    })
  },
  watch: {
    $route (to) {
      this.$nextTick(() => {
        this.ProjectList.forEach(item => {
          if (parseInt(item.id) === parseInt(to.params.id)) {
            this.proCity = item.city
          }
        })
        this.getAqi()
      })
    },
    Cityaqi (value) {
      this.$nextTick(() => {
        if (value) {
          this.item3 = []
          value.forEach((item, index) => {
            this.item3[index] = { type: item.date.substring(5), value: item.value }
          })
        }
      })
    },
    projectName () { // 项目变化----------------------
      this.$nextTick(() => {
        this.getAreaL()
      })
    },
    proAreaList (value) { // 地区列表-----------------
      this.$nextTick(() => {
        if (value.length) {
          this.aeraName = this.AreaName ? this.AreaName : value[0].name
          this.areaId = this.AreaID ? this.AreaID : value[0].id
        } else {
          this.aeraName = this.$store.state.module1.isChina ? '暂无场所' : 'null'
        }
      })
    },
    areaInfo (value) { // 地区详细变化----------------
      this.$nextTick(() => {
        this.changeNum()
      })
    },
    areaId () {
      this.$nextTick(() => {
        // 获取地区详情信息
        this.getAreaInfoDetail()
        // 获取地区设备列表
        this.getDevList()
        if (this.timerId3) {
          clearInterval(this.timerId3)
        }
        this.timerId3 = setInterval(() => {
          this.getDevList()
        }, 1000 * 60 * 2)
        this.devId = []
      })
    },
    state () { // 选择在线---------------
      this.$nextTick(() => {
        this.page = 1
        this.getDevList()
      })
    },
    deviceList (value) {
      this.$nextTick(() => {
        this.devLists = value
        this.devLists.forEach(dev => {
          if (this.devId) {
            this.devId.forEach(item => {
              if (dev.code === item.dev) {
                dev.color = item.color
              }
            })
          }
        })
      })
    },
    deviceLog (value) {
      this.$nextTick(() => {
        if (value) {
          if (this.devId.length) {
            var arr = []
            this.devId.forEach(item => {
              var data = value[item.dev]
              var da = data[data.length - 1]
              arr.push(da)
            })
            var dt = {
            }
            this.dt.forEach(key => {
              dt[key] = 0
            })
            this.dt.forEach(pa => {
              arr.forEach(item => {
                if (item[pa]) {
                  dt[pa] += parseInt(item[pa])
                }
              })
              dt[pa] = +(dt[pa] / this.devId.length).toFixed(1)
            })
            this.dt.forEach((key, index) => {
              this.parmasList[index].value = dt[key]
            })
            this.item2 = []
            this.depCopy(this.item2, this.parmasList)
            this.changUnit()
          }
        }
      })
    },
    devId: {
      handler (newValue) {
        this.$nextTick(() => {
          if (!newValue.length) {
            if (this.areaInfo.params) {
              this.changeNum()
              this.$store.commit('setDeviceLog', null)
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped lang='less'>
.allDev{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  margin:0.2rem 0;
  div{
    width:1.08rem;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    height:1.08rem;
    background:rgba(233,233,233,0.2);
    border-radius:0.12rem;
    font-size:0.16rem;
    p{
      font-size:0.4rem;
      font-weight:800;
      margin-bottom:0.1rem;
    }
  }
  div:hover{
    color:#42BAFF;
  }
}
.devLi{
  width:100%;
  padding:0.12rem 0.2rem;
  height:0.96rem;
  position:relative;
  background:rgba(233,233,233,0.2);
  display:flex;
  align-items:center;
  margin:0.16rem 0;
  border-radius:0.12rem;
  font-size:0.12rem;
     text-align:left;
  img{
    width:0.7rem;
    height:0.7rem;
    margin-right:0.1rem;
  }
  p{
    font-size:0.16rem;
    font-weight:600;
    margin-bottom:0.1rem;
  }
    span{
   font-size:0.12rem;
   text-align:left;
   opacity:0.6;
    }
  .showLine{
    position:absolute;
    right:0.1rem;
    top:0.2rem;
    font-size:0.12rem;
    transform:scale(0.8);
    border-radius:0.12rem;
    padding:0.04rem 0.1rem;
    display:flex;
    align-items:center;
    color:white;
    div{
      width:0.06rem;
      height:0.06rem;
      border-radius:50%;
      background:white;
      margin-right:0.05rem;
    }
  }
}
.devLi:hover{
    color:#42BAFF;
  }
.main-cont{
  width:100%;
  height:100%;
  display:flex;
}
.main-cont-left{
  width:12.28rem;
  height:calc(100% - 0.4rem);;
}
.main-cont-right{
  width:4.14rem;
  height:calc(100% - 0.28rem);
  margin:0.1rem 0;
  margin-left:0.1rem;
  overflow:auto;
  @media (max-width: 1280px) {
    width:3.6rem;
  }
}
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-weight:600;
    font-size: 0.16rem;
  }
  .el-icon-arrow-down {
    font-size: 0.12rem;
  }
.page-projectAreaDetail{
  width:100%;
  height:100%;
}
.el-breadcrumb__item{
  font-size:0.16rem;
}
.page-projectAreaDetail-header{
  width:100%;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.projectAreaDetail-header-input{
  height:0.4rem;
  width:4rem;
  background:white;
  border-radius:0.2rem;
  line-height:0.4rem;
  display:flex;
  justify-content:space-between;
  padding:0 0.3rem;
  align-items:center;
  margin-right:0.3rem;
  input {
    margin-left:0.2rem;
    height:0.4rem;
    width:80%;
    line-height:0.4rem;
  }
}
.projectAreaDetail-header-right{
  display:flex;
  align-items:center;
}
.el-range-separator{
  font-size:0.18rem;
}
.block{
  border-radius:0.2rem;
  overflow:hidden;
  input{
    border:none;
    outline:none;
  }
}
.el-range-editor{
    border:none;
    outline:none;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border:none;
    outline:none;
}
.dev1{
  height:4.68rem;
  width:4.02rem;
  margin-right:0.1rem;
}
.page-projectAreaDetail-second{
  display:flex;
  align-items:center;
  margin-top:0.1rem;
}
.dev-detail{
  width: 4.32rem;
  height:1.56rem;
  background:white;
  overflow:hidden;
}
.dev-manager{
  height:2.88rem;
  width:4.32rem;
  margin-top:0.24rem;
  overflow:hidden;
  background:#01A3FF;
}
.dev2{
  width:4.02rem;
  margin-left:0.1rem;
}
.dev3{
  width:4.02rem;
  height:4.68rem;
}
.zhedian{
  height:calc(100% - 4.65rem);
  width:100%;
  margin-top:0.1rem;
  overflow:auto;
  background:white;
}
.blue{
  background:rgba(24,144,255,0.4);
}
.green{
  background:rgba(0,198,87,0.4);
}
.orange{
  background:rgba(248,205,56,0.4);
}
</style>
